module.exports = __webpack_public_path__ + "static/media/skype.e61e3dfb.svg";